module.exports = __webpack_public_path__ + "static/media/fi-rr-diamond.d554cc82.svg";